
import React from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import TopBar from "./topbar";
import Footer from "./footer";

export default function NotFoundPage() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "125vh",
        bgcolor: "#FFFFFF",
      }}
    >
      {/* Top Navigation */}
      <TopBar />

      {/* Main Section */}
      <Box
        sx={{
          flex: 1,
          bgcolor: "#F6F7F9",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          py: 8,
          textAlign: "center",
        }}
      >
        <Container maxWidth="md">
          {/* Text-based 404 Display */}
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: "5rem", sm: "7rem", md: "9rem" },
              fontWeight: "bold",
              color: "#1976d2",
              mb: 2,
            }}
          >
            404
          </Typography>

          <Typography
            variant="h5"
            fontWeight="bold"
            color="text.primary"
            gutterBottom
          >
            Oops! Page Not Found.
          </Typography>

          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ mb: 4, maxWidth: 500, mx: "auto" }}
          >
            The page you’re looking for doesn’t exist, has been moved, or is temporarily unavailable.  
            Please check the URL or return to the homepage.
          </Typography>

          <Button
            variant="contained"
            color="primary"
            sx={{ borderRadius: 3, px: 4 }}
            href="/learner-dash"
          >
            Go Back Home
          </Button>
        </Container>
      </Box>

      {/* Footer */}
      <Footer />
    </Box>
  );
}
